import { render, staticRenderFns } from "./AtomStatus.vue?vue&type=template&id=4b472b42&"
import script from "./AtomStatus.vue?vue&type=script&lang=js&"
export * from "./AtomStatus.vue?vue&type=script&lang=js&"
import style0 from "./AtomStatus.vue?vue&type=style&index=0&id=4b472b42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/AtomStatus.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fatoms%2Fcommon%2FAtomStatus.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports